import PropTypes from 'prop-types';

import Checkbox from '../../../../common/inputs/checkbox/Checkbox';
import Button from '../../../../common/button/Button';

import { ReactComponent as LogoDark } from '../../../../../resources/logos/atp-logo-light.svg';

import './role-selection.scss';

const RoleSelection = ({ setScreenStep, addRole, removeRole, isRoleInList, isRolesEmpty, register }) => {
  const addOrRemoveRole = (role) => {
    if (isRoleInList(role)) {
      removeRole(role);
    } else {
      addRole(role);
    }
  };

  return (
    <section className="role_selection">
      <LogoDark className="role_selection__logo" />
      <section>
        <div className="role_selection__heading">
          <h1>Step 3: </h1>
          <h2>I am mainly interested in: </h2>
        </div>
        <div className="role_selection__body">
          <div className="role_selection__spacer" />
          <div className="role_selection__back">
            <p onClick={() => setScreenStep(2)}>{'<'} Back</p>
          </div>
          <div className="role_selection__step">
            <div>
              <div className="role_selection__checkbox">
                <Checkbox value={isRoleInList('buying')} onChange={() => addOrRemoveRole('buying')} />
                <p>Buying</p>
              </div>
              <div className="role_selection__checkbox">
                <Checkbox value={isRoleInList('selling')} onChange={() => addOrRemoveRole('selling')} />
                <p>Supplying</p>
              </div>
              <div className="role_selection__checkbox">
                <Checkbox value={isRoleInList('Broker')} onChange={() => addOrRemoveRole('Broker')} />
                <p>I am a broker</p>
              </div>
            </div>
          </div>
          <div className="role_selection__spacer" />
        </div>
        <div className="role_selection__button-container">
          <Button onClick={() => register()} disabled={isRolesEmpty()}>
            Register
          </Button>
        </div>
      </section>
    </section>
  );
};

RoleSelection.propTypes = {
  setScreenStep: PropTypes.func.isRequired,
  addRole: PropTypes.func.isRequired,
  removeRole: PropTypes.func.isRequired,
  isRoleInList: PropTypes.func.isRequired,
  isRolesEmpty: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
};

export default RoleSelection;
